import { getDefaultStore, useAtom } from 'jotai';

import { atomWithToggle } from '~shared/jotai/atomWithToggle';

export const resultsShowNameAtom = atomWithToggle(true);
export const reportsShowNameAtom = atomWithToggle(false);

export const useResultsShowName = () => useAtom(resultsShowNameAtom);

export const useReportsShowName = () => useAtom(reportsShowNameAtom);

export function useShowNames(isActivityInProgress: boolean) {
  const isResultsShowName = useResultsShowName();
  const isReportsShowName = useReportsShowName();

  return isActivityInProgress ? isResultsShowName : isReportsShowName;
}

export function resetShowNames() {
  const store = getDefaultStore();
  store.set(resultsShowNameAtom, true);
  store.set(reportsShowNameAtom, false);
}

export function useCopyShowNamesToReports() {
  const [, setShowName] = useReportsShowName();
  const [isResultsShowName] = useResultsShowName();
  return () => setShowName(isResultsShowName);
}
